import { render, staticRenderFns } from "./SelectorVocalInstrument.vue?vue&type=template&id=3f79939a&scoped=true&"
import script from "./SelectorVocalInstrument.vue?vue&type=script&lang=js&"
export * from "./SelectorVocalInstrument.vue?vue&type=script&lang=js&"
import style0 from "./SelectorVocalInstrument.vue?vue&type=style&index=0&id=3f79939a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f79939a",
  null
  
)

export default component.exports